import { render } from "./ServicesHome.vue?vue&type=template&id=2dca2e66&scoped=true"
import script from "./ServicesHome.vue?vue&type=script&lang=js"
export * from "./ServicesHome.vue?vue&type=script&lang=js"

import "./ServicesHome.vue?vue&type=style&index=0&id=2dca2e66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dca2e66"]])

export default __exports__